const RAYON_DECALAGE = 0.00004;

export default function separerCoordonneesDupliquees(liste) {
  const groupes = {};
  (liste || []).forEach((el) => {
    const cle = Number(el.latitude) + '|' + Number(el.longitude);
    if (!groupes[cle]) groupes[cle] = [];
    groupes[cle].push(el);
  });

  const resultat = [];
  Object.values(groupes).forEach((groupe) => {
    groupe.forEach((el, index) => {
      const latitude = Number(el.latitude);
      const longitude = Number(el.longitude);
      if (groupe.length < 2) {
        resultat.push(Object.assign({}, el, { latitude, longitude }));
        return;
      }
      const angle = (2 * Math.PI * index) / groupe.length;
      const correctionLongitude = Math.cos((latitude * Math.PI) / 180) || 1;
      resultat.push(Object.assign({}, el, {
        latitude: latitude + (RAYON_DECALAGE * Math.cos(angle)),
        longitude: longitude + ((RAYON_DECALAGE * Math.sin(angle)) / correctionLongitude),
      }));
    });
  });
  return resultat;
}



// WEBPACK FOOTER //
// ./src/services/catalogue/separerCoordonneesDupliquees.js